import getConfig from 'next/config';

import type { NextConfig } from 'src/types/nextConfig';

type ListingsAPIResource = 'listings' | 'recommendations';

/*
  The private (in-mesh) and public hosts expose the same resources under
  different paths, so the path depends on which host we are talking to.
*/
const PATHS: Record<ListingsAPIResource, { clientSide: string; serverSide: string }> = {
  listings: {
    serverSide: '/api/v1/listings',
    clientSide: '/api/listings/v1',
  },
  recommendations: {
    serverSide: '/api/v1/recommendations',
    clientSide: '/api/recommendations/v1',
  },
};

export const getListingsAPIUrl = (resource: ListingsAPIResource, clientSide: boolean) => {
  const { publicRuntimeConfig } = getConfig() as NextConfig;
  const { listings, listingsPublic } = publicRuntimeConfig.endpoints;
  const host = clientSide ? listingsPublic : listings;
  const path = clientSide ? PATHS[resource].clientSide : PATHS[resource].serverSide;

  return `${host.replace(/\/$/, '')}${path}`;
};
